









import { Component, Vue } from 'vue-property-decorator'

// components
import vertical from './vertical.vue'
import horizontal from './horizontal.vue'

@Component({
  name: 'MainLayout',
  components: {
    vertical,
    horizontal
  }
})
export default class MainLayout extends Vue {
  get layoutType (): string {
    return this.$store.state.layout.layoutType
  }
}
